// Pure helpers extracted from src/pages/Excerpts.tsx.
const escapeRegex = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const countTokenHits = (text: string, tokens: string[]) => {
  if (!text || tokens.length === 0) return 0;
  const pattern = new RegExp(tokens.map(escapeRegex).join("|"), "gi");
  return (text.match(pattern) ?? []).length;
};
